import { HOME_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const homeTabRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'hometab',
	path: HOME_PATH,
	layout: 'home',
});
